import { InjectionToken } from '@angular/core';
import { Environment } from './environment.model';

export const INSIDE_APP_ENVIRONMENT = new InjectionToken<Environment>('Environment variable of the app wheere inside');
